/* Wave2Wear wishlist — localStorage hearts + wishlist page. No login required. */
(function () {
  var KEY = 'w2w_wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} updateCounts(); }
  function has(h) { return get().indexOf(h) !== -1; }
  function toggle(h) { var a = get(), i = a.indexOf(h); if (i === -1) a.push(h); else a.splice(i, 1); save(a); return i === -1; }
  function updateCounts() { var n = get().length; document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, cur) { try { return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + (cur || 'EUR'); } }

  function syncHearts(scope) {
    (scope || document).querySelectorAll('.w2w-wish').forEach(function (b) {
      var a = has(b.getAttribute('data-handle'));
      b.classList.toggle('is-active', a);
      b.setAttribute('aria-pressed', a ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.w2w-wish'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle'); if (!h) return;
    var added = toggle(h);
    document.querySelectorAll('.w2w-wish[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]').forEach(function (x) {
      x.classList.toggle('is-active', added); x.setAttribute('aria-pressed', added ? 'true' : 'false');
    });
    var page = b.closest('[data-wishlist-page]');
    if (page && !added) {
      var card = b.closest('.w2w-wishcard'); if (card) card.remove();
      var grid = page.querySelector('[data-wishlist-grid]');
      if (grid && !grid.children.length) page.querySelector('[data-wishlist-empty]').hidden = false;
    }
  });

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]'); if (!page) return;
    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var cur = page.getAttribute('data-currency') || 'EUR';
    var handles = get();
    if (!handles.length) { empty.hidden = false; return; }
    empty.hidden = true;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list.filter(Boolean).forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        var card = document.createElement('div');
        card.className = 'w2w-wishcard';
        card.innerHTML =
          '<a class="w2w-wishcard__media" href="' + p.url + '"><img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
          '<a class="w2w-wishcard__name" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<span class="w2w-wishcard__price">' + money(p.price, cur) + '</span>' +
          '<button type="button" class="w2w-wishcard__remove w2w-wish is-active" data-handle="' + esc(p.handle) + '" aria-pressed="true">Remove</button>';
        grid.appendChild(card);
      });
      if (!grid.children.length) empty.hidden = false;
    });
  }

  function boot() { syncHearts(); updateCounts(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
